<template>
  <div class="gathering3">
    <p>Annan text</p>

    <form>
      <input
        class="gathering3__form-submit"
        type="submit"
        name="submit"
        id="submit"
        value="Nästa steg"
        v-on:click="done($event)"
      />
    </form>
  </div>
</template>

<script>
export default {
  name: 'GatheringStep2',
  methods: {
    done (event) {
      this.$emit('clicked', event);
    }
  }
}
</script>

<style lang="scss" scoped>
.gathering3 {
  &__form {
    &-submit {
      border-radius: 1.5em;
      border: none;
      cursor: pointer;
      font-size: 1rem;
      text-transform: uppercase;
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      transition: all .5s;
      padding: 13px 25px;
      color: $white;
      background-color: $mediumGreen;

      &:hover {
        background-color: $lightGreen;
      }
    }
  }
}
</style>